import React from "react";
import OpenPDFButton from "./OpenPDFButton";
import companyInfo from "../data/companyInfo";

function AboutUs() {
  return (
    <section
      className="bizmak-section bizmak-section-dark page-section mb-0"
      id="aboutus"
    >
      <div className="container">
        <h2 className="page-section-heading text-center text-white mb-0">
          About BizMak
        </h2>
        <p className="section-intro">
          A Maryland-based IT consulting firm serving commercial enterprises
          and government agencies from Catonsville, MD.
        </p>
        <div className="divider-custom divider-light">
          <div className="divider-custom-line" />
          <div className="divider-custom-icon">
            <i className="fas fa-star" aria-hidden="true" />
          </div>
          <div className="divider-custom-line" />
        </div>

        <div className="row justify-content-center g-4">
          <div className="col-lg-10 col-xl-8">
            <div className="bizmak-feature mb-0">
              <div className="bizmak-feature-icon" aria-hidden="true">
                <i className="fas fa-building" />
              </div>
              <p>
                BizMak Inc, led by President {companyInfo.contact.name}, helps
                organizations modernize how they work. Our specialty is
                transforming manual, paper-based operations into efficient,
                automated web-based systems — work that Fortune 500 companies
                including ADT Inc, CGI Inc, and The Judge Group have relied on
                us to deliver.
              </p>
            </div>
          </div>
          <div className="col-lg-10 col-xl-8">
            <div className="bizmak-feature mb-0">
              <div className="bizmak-feature-icon" aria-hidden="true">
                <i className="fas fa-layer-group" />
              </div>
              <p>
                Our team combines senior software engineers, QA automation
                architects, cloud specialists, and security practitioners
                recognized by top-tier companies for their expertise. That
                depth lets one partner take an initiative from strategy through
                development, testing, deployment, and ongoing operations.
              </p>
            </div>
          </div>
          <div className="col-lg-10 col-xl-8">
            <div className="bizmak-feature mb-0">
              <div className="bizmak-feature-icon" aria-hidden="true">
                <i className="fas fa-shield-halved" />
              </div>
              <p>
                Security and reliability run through everything we build. We
                invest in continuous training, strengthen our security
                practices every year, and monitor client systems proactively —
                intercepting problems before they interrupt your business.
              </p>
            </div>
          </div>
          <div className="col-lg-10 col-xl-8">
            <div className="bizmak-feature mb-0">
              <div className="bizmak-feature-icon" aria-hidden="true">
                <i className="fas fa-handshake" />
              </div>
              <p>
                Whether you're a growing business that needs a dependable
                technology partner or a government agency seeking a registered
                federal supplier, we'd welcome the conversation. Call us at{" "}
                {companyInfo.contact.phone} or use the contact form below.
              </p>
            </div>
          </div>
        </div>

        <div className="text-center mt-5">
          <OpenPDFButton variant="light" />
        </div>
      </div>
    </section>
  );
}

export default AboutUs;
